import { useState } from "react";
import Button from "@components/AccessibleComponents/Button";
import Tooltip from "@components/AccessibleComponents/Tooltip";
import TooltipTrigger from "@components/AccessibleComponents/TooltipTrigger";
import { useUserInfo } from "@features/mySph/hooks/useUserInfo";
import { cn } from "@util/helpers";

export default function NewsletterSubscriberOnly(): React.ReactElement {
  const { isSubscriber } = useUserInfo();
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  return (
    <>
      <TooltipTrigger
        delay={0}
        closeDelay={0}
        key="test"
        isOpen={isTooltipVisible}
      >
        <div
          className={cn("flex flex-row flex-wrap gap-x-3")}
          onMouseEnter={() => {
            setIsTooltipVisible(true);
          }}
          onMouseLeave={() => {
            setIsTooltipVisible(false);
          }}
        >
          <Button
            className={cn(
              "absolute bottom-0 border border-black px-2 py-1 font-public-sans text-[14px] font-normal",
              isSubscriber ? "right-0" : "left-0"
            )}
          >
            Subscriber Only
          </Button>
        </div>

        <Tooltip className="rounded bg-gray-850 px-4 py-2 font-poppins text-xs font-normal text-white">
          Subscribe to BT to sign up to this newsletter.
        </Tooltip>
      </TooltipTrigger>
    </>
  );
}
